import { Button } from "flowbite-react"
import React, { Dispatch, ReactNode, SetStateAction, useEffect } from "react"

import CustomImage from "@components/elements/CustomImage"
import StripHTMLAndAddEllipses from "@components/elements/StripHTMLAndAddEllipses"
import { ProductCategoryType, ProductType } from "@mono/essentials/types/OrderTypes"

interface CategoryPreviewType {
  categoryList?: ProductCategoryType[]
  setSelectedProductCategory: Dispatch<React.SetStateAction<ProductCategoryType | undefined>>
  goToNextStep: (
    category_id?: string,
    product?: ProductType,
    product_info?: ProductType,
    hasMultiProduct?: boolean
  ) => void
  setShow?: Dispatch<React.SetStateAction<boolean>>
  setModalHeading?: Dispatch<SetStateAction<string | ReactNode>>
  isModal?: boolean
}

const CategoryPreview = ({
  categoryList,
  setSelectedProductCategory,
  goToNextStep,
  setShow,
  isModal,
}: CategoryPreviewType) => {
  const handleProductCategorySelect = (selectedProductCategory: ProductCategoryType) => {
    setSelectedProductCategory(selectedProductCategory)
    const activeProduct = selectedProductCategory?.activeProducts[0]
    const hasSingleProduct = selectedProductCategory?.activeProducts?.length === 1
    goToNextStep(
      selectedProductCategory?.id,
      hasSingleProduct ? activeProduct : null,
      null,
      hasSingleProduct
    )
    setShow?.(true)
  }

  return (
    <>
      {categoryList?.map((productCategory, index) =>
        productCategory.activeProducts.length ? (
          <div
            key={`${productCategory.id}_${index}`}
            className={`image-gradiant after:rounded-md
              ${productCategory.cover_image ? `` : "bg-imagePlaceholderBackground"}
              relative flex h-full md:min-h-[224px] sm:min-h-[180px] min-h-[230px] md:min-w-[300px] sm:min-w-[250px] w-full cursor-pointer flex-row items-end
              rounded-lg bg-cover bg-center shadow-sm !overflow-hidden
            `}
            data-testid={"category-card"}
            onClick={() => handleProductCategorySelect(productCategory)}
          >
            {!productCategory.cover_image ? (
              <div
                className={
                  "absolute left-1/2 top-1/2 h-11 w-[52px] -translate-x-1/2 -translate-y-1/2 transform bg-transparent bg-imagePlaceholder bg-contain bg-center bg-no-repeat"
                }
              />
            ) : (
              <CustomImage
                src={productCategory.cover_image}
                className={"overflow-hidden rounded-lg"}
                fill
                objectFit={"cover"}
              />
            )}
            <div
              className={`flex flex-1 flex-row text-whiteBlack-100 z-[9] absolute w-full rounded-b-lg bg-black/[.64] px-3 pt-2 pb-3 items-center justify-between gap-2`}
            >
              <StripHTMLAndAddEllipses
                content={productCategory?.name}
                maxLength={75}
                className={"sm:text14Semibold text15Semibold drop-shadow-sm relative"}
              />
              <div className={"flex justify-end items-center"}>
                <Button
                  color={"primary"}
                  className={"[&>span]:py-2 [&>span]:text14Medium"}
                  size={"xs"}
                >
                  Book
                </Button>
              </div>
            </div>
          </div>
        ) : null
      )}
    </>
  )
}

export default CategoryPreview
